<app-form-header *ngIf="isRegisterPage"></app-form-header>